import { atom } from "recoil";

const Language = atom({
    key: "Language",
    default: "ENG",
});

export default Language;
